<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <div class="bjgl-search">
      <el-select v-model="searchYwcode" clearable placeholder="请选择业务" style="width: 150px;margin-right: 10px;margin-bottom: 10px;">
        <el-option v-for="(item,index) in ywList" :key="index" :label="item.ywmc" :value="item.ywcode"></el-option>
      </el-select>
      <el-select v-model="kbzt" clearable placeholder="请选择开班状态" style="width: 150px;margin-right: 10px;margin-bottom: 10px;">
        <el-option v-for="(item,index) in kbztList" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input v-model="bjmc" clearable placeholder="请输入班级名称" style="width: 180px;margin-right: 10px;margin-bottom: 10px;"></el-input>
      <el-button @click="searchBjgl" style="margin-right: 10px;margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
      <el-button type="primary" @click="addBjgl" style="margin: 0 10px 10px 0;" icon="el-icon-plus">新增</el-button>
    </div>
    <div class="bjgl-table">
      <el-table	:data="tableData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column type="index" align="center" width="80" label="序号"></el-table-column>
        <el-table-column prop="bjmc" label="班级"></el-table-column>
        <el-table-column prop="ywmc" label="业务"></el-table-column>
        <el-table-column prop="hbjb" label="包含绘本级别"></el-table-column>
        <el-table-column align="center" width="100" label="开班时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.kbsj),'yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" label="结课时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.jksj),'yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" label="学生数">
          <template slot-scope="scope">
            {{ scope.row.xsrs }} / {{ scope.row.bjrs }}
          </template>
        </el-table-column>
        <el-table-column prop="jsmc" label="教师"></el-table-column>
        <el-table-column align="center" width="80" label="状态">
          <template slot-scope="scope">
<!--            <span v-if="scope.row.zt == 0">未开班</span>
            <span v-if="scope.row.zt == 1">已开班</span>
            <span v-if="scope.row.zt == 2">已结课</span>-->
            <el-tag size="mini" v-if="scope.row.zt==0" type="info">未开班</el-tag>
            <el-tag size="mini" v-if="scope.row.zt==1">已开班</el-tag>
            <el-tag size="mini" v-if="scope.row.zt==2" type="danger">已结课</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="cjrmc" label="创建人">
        </el-table-column>
        <el-table-column align="center" width="160" label="创建时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.cjsj),'yyyy-MM-dd hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="bjxsView(scope.row.id)">查看学生</el-button>
            <el-button type="text" @click="bjglShow(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="bjglDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="page-zj"
          v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
      </el-pagination>

      <el-dialog
          :title="dialogTitle?'编辑':'新增'"
          :visible.sync="dialogVisible"
          width="30%"
          @close="handleClose"
          :close-on-click-modal="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
          <el-form-item label="班级名称" prop="bjmc">
            <el-input v-model="ruleForm.bjmc" show-word-limit maxlength="30" clearable placeholder="请输入班级名称"></el-input>
          </el-form-item>
          <el-form-item label="业务" prop="ywcode">
            <el-select v-model="ruleForm.ywcode" clearable placeholder="请选择业务" @change="findZyjbList">
              <el-option
                  v-for="item in ywList"
                  :key="item.ywcode"
                  :label="item.ywmc"
                  :value="item.ywcode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="包含绘本级别" prop="jbIds">
            <el-select v-model="ruleForm.jbIds" multiple clearable placeholder="请选择包含绘本级别">
              <el-option
                  v-for="item in zyjbList"
                  :label="item.jbmc"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级人数" prop="bjrs">
            <el-input v-model="ruleForm.bjrs" show-word-limit maxlength="10" clearable placeholder="请输入班级人数"></el-input>
          </el-form-item>
          <el-form-item label="开班时间" prop="kbsj">
            <el-date-picker
                v-model="ruleForm.kbsj"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结课时间" prop="jksj">
            <el-date-picker
                v-model="ruleForm.jksj"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="教师" prop="jsIds">
            <el-select v-model="ruleForm.jsIds" multiple clearable placeholder="请选择教师">
              <el-option
                  v-for="item in jiaoshiList"
                  :label="item.jsmc"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="bjglSave('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
          title="查看学生"
          :visible.sync="bjxsDialogVisible"
          width="60%"
          :close-on-click-modal="false">
        <el-button type="primary" @click="bjglXueyuanExport" style="margin: 0 10px 10px 0;">导出学生信息</el-button>
        <el-table	:data="bjxsData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
          <el-table-column type="index" align="center" width="80" label="序号">
          </el-table-column>
          <el-table-column prop="xueyuanBm" label="学生编码">
          </el-table-column>
          <el-table-column prop="xueyuanMc" label="学生姓名">
          </el-table-column>
          <el-table-column prop="xueyuanYwmc" label="学生英文名">
          </el-table-column>
          <el-table-column label="性别" width="50">
            <template slot-scope="scope">
              <span v-if="scope.row.xb == 0">男</span>
              <span v-if="scope.row.xb == 1">女</span>
            </template>
          </el-table-column>
          <el-table-column prop="lxdh" label="联系电话">
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="bjxsDel(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="bjxsDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
	</div>
</template>

<script>
	export default{
		name: "bjglList",
		data() {
		  return {
        jgglId: sessionStorage.getItem("jgglId"),
        loading: false,
        tableData: [],
        page: { page: 1, size: 10, total: 0 },
        kbzt: '',//开班状态
        searchYwcode: '',
        kbztList: [
          {value: 0, label: '未开班'},
          {value: 1, label: '已开班' },
          {value: 2, label: '已结课'},
        ],
        ywList: [],
        bjmc: '',//班级名称
        zyjbList: [],
        jiaoshiList: [],
        dialogVisible: false,
        dialogTitle: false,
        ruleForm: {
          id: '',
          jgglId: sessionStorage.getItem("jgglId"),
          bjmc: '',
          ywcode: '',
          jbIds: [],
          jbList: [],
          bjrs: '',
          kbsj: '',
          jksj: '',
          jsIds: [],
          jsList: []
        },
        rules: {
          bjmc: [
            { required: true, message: '请输入班级名称', trigger: 'blur' }
          ],
          ywcode: [
            { required: true, message: '请选择业务', trigger: 'change' }
          ],
          jbIds: [
              { required: true, message: '请选择包含绘本级别', trigger: 'change' }
          ],
          bjrs: [
            { required: true, message: '请输入班级人数', trigger: 'blur' }
          ],
          kbsj: [
              { required: true, message: '请选择开班时间', trigger: 'change' },
              {
                validator: (rule, value, callback) => {
                  if (value && new Date(value).getTime() < new Date().setHours(0,0,0,0) && !this.ruleForm.id) {
                    callback(new Error('开班时间不能早于当前时间'));
                  } else if (value && this.ruleForm.jksj && new Date(value).getTime() > new Date(this.ruleForm.jksj).getTime()) {
                    callback(new Error('开班时间不能晚于结课时间'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change'
              }
          ],
          jksj: [
              { required: true, message: '请选择结课时间', trigger: 'change' },
              {
                validator: (rule, value, callback) => {
                  if (value && this.ruleForm.kbsj && new Date(value).getTime() < new Date(this.ruleForm.kbsj).getTime()) {
                    callback(new Error('结课时间不能早于开班时间'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change'
              }
          ],
          jsIds: [
              { required: true, message: '请选择教师', trigger: 'change' }
          ]
        },
        bjxsDialogVisible: false,
        bjId: '',
        bjxsData: [],
		  }
		},
		mounted() {
			this.findBjglPage();
      //this.findZyjbList();
      this.findJiaoshiList();
      this.findJgYwList();
		},
		methods: {
      bjxsDel(id){
        var _this = this;
        _this.$confirm('是否确认删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$post("bjgl/BjglController/bjxsDel", { bjglId:_this.bjId,xueyuanId: id }).then(rep => {
            if (rep.code == '1') {
              _this.$message({
                type: "success",
                message: '删除成功'
              });
              _this.bjxsView(_this.bjId);
              _this.findBjglPage()
            } else {
              _this.$message({
                type: "error",
                message: rep.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      },
      bjxsView(id){
        var _this = this;
        _this.bjId = id;
        _this.loading = true;
        _this.$post('bjgl/BjglController/bjxsbmList',{jgglId: _this.jgglId, bjglId: _this.bjId}).then((rep) => {
          _this.loading = false;
          if(rep.code == 1){
            _this.bjxsData = rep.result.list;
            _this.bjxsDialogVisible = true;
          }else{
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      bjglXueyuanExport(){
        var access_token = sessionStorage.getItem("access_token");
        let url = "api/bjgl/BjglController/bjglXueyuanExport";
        url = url + "?access_token=" + access_token
            +"&dlsglId=" + this.jgglId
            +"&bjglId=" + this.bjId;
        window.location.href = url;
      },
      bjglSave(formName){
        var _this = this;
        _this.$refs[formName].validate((valid) => {
          if(valid){

            //获取绘本级别
            _this.ruleForm.jbList = [];
            _this.ruleForm.jbIds.forEach(item => {
              _this.zyjbList.forEach(item1 => {
                if(item == item1.id){
                  _this.ruleForm.jbList.push({jbId: item1.id, jbMc: item1.jbmc});
                }
              })
            })
            //获取教师
            _this.ruleForm.jsList = [];
            _this.ruleForm.jsIds.forEach(item => {
              _this.jiaoshiList.forEach(item1 => {
                if(item == item1.id){
                  _this.ruleForm.jsList.push({jiaoshiId: item1.id, jiaoshiMc: item1.jsmc});
                }
              })
            })

            _this.loading = true;
            _this.$post('bjgl/BjglController/bjglSave',this.ruleForm, 'json').then((rep) => {
              _this.loading = false;
              if (rep.code == 1) {
                _this.$message({
                  type: "success",
                  message: this.dialogTitle ? '编辑成功' : '添加成功'
                });
                _this.dialogVisible = false;
                _this.findBjglPage();
              } else {
                _this.$message({
                  type: "error",
                  message: rep.msg
                });
              }
            });
          }else {
            return false;
          }
        });
      },
      bjglShow(id){
        var _this = this;
        _this.loading = true;
        _this.$post('bjgl/BjglController/bjglView',{id: id}).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            var bjgl = rep.result.bjgl;
            _this.ruleForm.id = bjgl.id;
            _this.ruleForm.jgglId = bjgl.jgglId;
            _this.ruleForm.bjmc = bjgl.bjmc;
            _this.ruleForm.ywcode = bjgl.ywcode;
            _this.findZyjbList(false);
            _this.ruleForm.bjrs = bjgl.bjrs;
            _this.ruleForm.kbsj = bjgl.kbsj;
            _this.ruleForm.jksj = bjgl.jksj;

            _this.ruleForm.jbIds = [];
            bjgl.jbList.forEach(item => {
              _this.ruleForm.jbIds.push(item.jbId)
            });

            _this.ruleForm.jsIds = [];
            bjgl.jsList.forEach(item => {
              _this.ruleForm.jsIds.push(item.jiaoshiId)
            })
            _this.dialogVisible = true;
            _this.dialogTitle = true;
          }else{
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        });
      },
      addBjgl(){
        var _this = this;
        _this.ruleForm.jgglId = _this.jgglId;
        _this.dialogVisible = true;
        _this.dialogTitle = false;
      },
      // 弹窗关闭时
      handleClose() {
        var _this = this;
        _this.$refs['ruleForm'].resetFields();
        _this.ruleForm = {
          id: '',
          bjmc: '',
          ywcode: '',
          jbIds: [],
          bjrs: '',
          kbsj: '',
          jksj: '',
          jsIds: []
        };
        _this.dialogVisible = false;
      },
      bjglDel(id){
        var _this = this;
        _this.$confirm('是否确认删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$post("bjgl/BjglController/bjglDel", { id: id }).then(rep => {
            if (rep.code == '1') {
              _this.$message({
                type: "success",
                message: '删除成功'
              });
              _this.findBjglPage();
            } else {
              _this.$message({
                type: "error",
                message: rep.msg
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        })
      },
      searchBjgl(){
        var _this = this;
        _this.page.page = 1;
        _this.findBjglPage();
      },
      findBjglPage(){
        var _this = this;
        var params = {
          jgglId: _this.jgglId,
          zt: _this.kbzt,
          ywcode: _this.searchYwcode,
          bjmc: _this.bjmc,
          page: _this.page.page - 1,
          size: _this.page.size
        }
        _this.loading = true;
        _this.$post('bjgl/BjglController/bjglPage',params).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.tableData = rep.result.page.content;
            _this.page.total = rep.result.page.totalElements;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
			},
      // 每页条数
      handleSizeChange(val) {
        this.page.size = val;
        this.findBjglPage();
      },
      // 当前页
      handleCurrentChange(val) {
        this.page.page = val;
        this.findBjglPage();
      },
      findJiaoshiList(){
        var _this = this;
        _this.$post('jiaoshi/JiaoshiController/jiaoshiList',  {jgglId: _this.jgglId}).then((rep) => {
          if (rep.code == 1) {
            _this.jiaoshiList = rep.result.list;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
      },
      findZyjbList(clear){
        var _this = this;
        _this.$post('user/HbglController/hbjbList',{ywcode: _this.ruleForm.ywcode}).then((rep) => {
          if (rep.code == 1) {
            if(clear !== false){
              _this.ruleForm.jbIds = [];
            }
            _this.zyjbList = rep.result.list;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
      },
      findJgYwList(){
        var _this = this;
        _this.$post('bjgl/JgglController/findJgglYwListByJgglId', {jgglId: _this.jgglId}).then((rep) => {
          if (rep.code == 1) {
            _this.ywList = rep.result.ywList;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
		}
	}
</script>

<style lang="less" scoped>
  .bjgl-search{
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
  }
	.bjgl-table{
		.el-table{
		}
		.page-zj{
			width: 90%;
			text-align: right;
			margin: 0 auto;
			margin-top: 20px;
		}
	}
  .el-dialog{
    .el-form{
      padding-right: 20px;
      .el-select{
        width: 100%;
      }
      .el-date-editor{
        width: 100%;
      }
    }
  }
</style>